module.exports = __webpack_public_path__ + "img/img-soporte-tecnico.52737827.webp";